import { useUserStore } from '@/pinia/user'

const BASE_URL = import.meta.env.VITE_API_AI_URL

/**
 * 用于请求AI接口
 * @param {string} url 请求地址
 * @param {object} options 请求配置
 * @param {object} headers 额外的headers
 * @param {AbortController} abortController 可选的AbortController实例用于取消请求
*/
export const aiFetch = async (url, options = {}, headers = {}, abortController = null) => {
  const user = useUserStore()

  if (localStorage.getItem('deviceId') === null) {
    localStorage.setItem('deviceId', 'web' + Math.random().toString(36).substr(2))
  }

  const defaultOptions = {
    method: 'GET', // 默认 GET 请求
    headers: {
      'Content-Type': 'application/json',
      tk: user.userInfo.tk || '',
      deviceId: localStorage.getItem('deviceId'),
      userId: user.userInfo.uid,
      ...headers
    },
    ...options
  }

  // 如果提供了 AbortController，添加到 signal 中
  if (abortController) {
    defaultOptions.signal = abortController.signal
  }

  try {
    const response = await fetch(`${BASE_URL}${url}`, defaultOptions)
    // 检查响应的 Content-Type 来决定如何解析
    const contentType = response.headers.get('content-type')
    
    if (contentType && contentType.includes('application/json')) {
      const data = await response.json()
      return data
    } else {
      // 如果不是JSON，返回文本内容
      const text = await response.text()
      return text
    }
  } catch (error) {
    // 如果是取消请求，不打印错误
    if (error.name === 'AbortError') {
      console.log('aiFetch request was cancelled')
      throw error
    }
    console.log('aiFetch error', error)
    throw error
  }
}